export default __webpack_public_path__ + "static/media/world-needs-you-card.afa3e659.png";